import React, { useEffect, useState } from 'react';
import { postJobData, getDropdown, getJobsInformation } from '../service/RecruiterApi';
import Select from 'react-select';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import { useNavigate } from 'react-router-dom';
// import Loader from '../../StaticComponent/Loader';
import { OnlyNumberSpecialChar } from '../utils/RegHandling';
import { encryptStorage } from '../constant';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

/**
 * PS_01 -- User clicks on the New Job Posting and gets navigated to the Job creation page.
*/
export function JobPosting() {
    const jobEditId = new URLSearchParams(window.location.search).get('id');

    let breadCrumbsData = [
        { title: 'Dashboard', path: '/dashboard', isActive: true },

        { title: 'Jobs', path: '/Recruitment', isActive: true },

        { title: 'Add Job Posting', path: '/AddJobs', isActive: false },
    ];

    const navigate = useNavigate();

    const postById = encryptStorage.getItem('employeeId');
    let jobPostingFields = {
        jobTitle: '',
        departmentID: 0,
        employmentID: 0,
        no_of_resource: '',
        currencyID: 0,
        minSalary: '',
        maxSalary: '',
        payoutFrequency: 0,
        location: '',
        remoteJob: false,
        experience: '',
        sourceID: '',
        college: '',
        description: '',
        draft: false,
        isPublished: false,
        isClosed: false,
        isDeleted: false,
        isHold: false,
        allowApply: false,
        posted_by: postById,
        criticalityID: 1,
        skills: '',
    };


    const [previewData, setPreviewData] = useState({
        departmentID: '',
        currencyID: '',
        employmentID: '',
        payoutFrequency: '',
        sourceID: '',
        college: '',
    });

   /**
    * PS_03 - PS_04 -- Declaring the state variable and set function as empty array
    */
    const [formData, setFormData] = useState(jobPostingFields);
    const [departmentDD, setDepartmentDD] = useState([]);
    const [empTypeDD, setEmpTypeDD] = useState([]);
    const [currencyDD, setCurrencyDD] = useState([]);
    const [payFrequencyDD, setPayFrequencyDD] = useState([]);
    const [sourceDD, setSourceDD] = useState([]);
    const [collegeDD, setCollegeDD] = useState([]);
    const [typeSkills, setTypeSkills] = useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    const [jobtitleValidation, setJobtitleValidation] = useState('');
    const [departmentValidation, setDepartmentValidation] = useState('');
    const [employmentValidation, setEmploymentValidation] = useState('');
    const [resourceValidation, setResourceValidation] = useState('');
    const [currencyValidation, setCurrencyValidation] = useState('');
    const [minSalaryValidation, setMinSalaryValidation] = useState('');
    const [maxSalaryValidation, setMaxSalaryValidation] = useState('');
    const [payoutValidation, setPayoutValidation] = useState('');
    const [locationValidation, setLocationValidation] = useState('');
    const [experienceValidation, setExperienceValidation] = useState('');
    const [sourceValidation, setSourceValidation] = useState('');
    const [collegeValidation, setCollegeValidation] = useState('');
    const [descriptionValidation, setDescriptionValidation] = useState('');
    const [skillValidation, setSkillValidation] = useState('');

    let [hideSuccessPopup, setHideSuccessPopup] = useState(true);
    let [remoteDisable, setRemoteDisable] = useState(false);
    const [convertedText, setConvertedText] = useState('');

   /**
    * PS_02 --  useEffect gets triggered
    */
    useEffect(() => {
        if (jobEditId != null) {
            getJobEditData();
        }
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('recruitRole') == 'Panel Member') {
            loadForm();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);

   /**
    * PS_05 --In editObject payload the key names "source" and "college" is Added
    */
    let getJobEditData = async () => {
        let resp = await getJobsInformation({ jobID: jobEditId });
        let editObject = {
            jobTitle: resp.data.data[0].job_title,
            departmentID: resp.data.data[0].department_id,
            employmentID: resp.data.data[0].employment_id,
            no_of_resource: resp.data.data[0].no_of_source,
            currencyID: resp.data.data[0].currency_id,
            minSalary: resp.data.data[0].min_salary,
            maxSalary: resp.data.data[0].max_salary,
            payoutFrequency: resp.data.data[0].payout_frequency_id,
            location: resp.data.data[0].location,
            remoteJob: resp.data.data[0].remote_job,
            experience: resp.data.data[0].experience,
            sourceID: resp.data.data[0].source_id,
            college: resp.data.data[0].college,
            description: resp.data.data[0].description,
            draft: resp.data.data[0].draft,
            isPublished: resp.data.data[0].is_published,
            isClosed: resp.data.data[0].is_closed,
            isDeleted: resp.data.data[0].is_delete,
            isHold: resp.data.data[0].is_hold,
            allowApply: resp.data.data[0].allow_apply,
            posted_by: postById,
            criticalityID: resp.data.data[0].criticality_id,
            skills: resp.data.data[0].name,
        };
        setFormData(editObject);

        let previewObj = {
            departmentID: resp.data.data[0].department,
            currencyID: resp.data.data[0].currency_type,
            employmentID: resp.data.data[0].employment_type,
            payoutFrequency: resp.data.data[0].frequency,
            sourceID: resp.data.data[0].source,
            college: resp.data.data[0].college,
        };
        setPreviewData(previewObj);
    };
/**
 * PS_06 - 07 -- getDropdown function is declared and API call have been made
 */
    let loadForm = async () => {
        try {
            setIsLoading(false);
            let resp = await getDropdown();
            
            setIsLoading(true);
            setDepartmentDD(resp.data.data[0]);
            setEmpTypeDD(resp.data.data[1]);
            setCurrencyDD(resp.data.data[2]);
            setPayFrequencyDD(resp.data.data[3]);
            setSourceDD(resp.data.data[4]);
            setCollegeDD(resp.data.data[5]);
        } catch (e) { }
    };
/**
 * PS_25
 */
    let onValueChange = (e) => {
        if (e.target.id == 'jobTitle' && e.target.value != '') {
            setJobtitleValidation('');
        } else if (e.target.id == 'departmentID' && e.target.value != '') {
            setDepartmentValidation('');
        } else if (e.target.id == 'employmentID' && e.target.value != '') {
            setEmploymentValidation('');
        } else if (e.target.id == 'no_of_resource' && e.target.value != '') {
            setResourceValidation('');
        } else if (e.target.id == 'currencyID' && e.target.value != '') {
            setCurrencyValidation('');
        } else if (e.target.id == 'minSalary' && e.target.value != '') {
            setMinSalaryValidation('');
        } else if (e.target.id == 'maxSalary' && e.target.value != '') {
            setMaxSalaryValidation('');
        } else if (e.target.id == 'payoutFrequency' && e.target.value != '') {
            setPayoutValidation('');
        } else if (e.target.id == 'location' && e.target.value != '') {
            setLocationValidation('');
        } else if (e.target.id == 'experience' && e.target.value != '') {
            setExperienceValidation('');
        } else if (e.target.id == 'sourceID' && e.target.value != '') {
            setSourceValidation('');
        } else if (e.target.id == 'college' && e.target.value != '') {
            setCollegeValidation('');
        } else if (e.target.id == 'skills' && e.target.value != '') {
            setSkillValidation('');
        }
        // } else if (e.target.id == 'description' && e.target.value != '') {
        //     setDescriptionValidation('');
        // }
        // else {
        //     if (convertedText !== '') {
        //         setDescriptionValidation('');
        //     }
        // }
        if (e.target.id == 'minSalary' && e.target.value != '') {
            // let regexItem = new RegExp('/^[1-9]\d*(?:\.\d{0,2})?$/');
            // let checkValid = regexItem.test(e.target.value);
            // let finalcheck=parseFloat(e.target.value)
            //

            if (isNaN(e.target.value)) {
                setMinSalaryValidation('Enter a Valid Min Salary');
            } else {
                setMinSalaryValidation('');
            }
        }
        if (e.target.id == 'maxSalary' && e.target.value != '') {
            let regexItem = new RegExp('^[0-9]*$');
            let check = regexItem.test(e.target.value);
            if (isNaN(e.target.value)) {
                setMaxSalaryValidation('Enter a Valid Max Salary');
            } else {
                setMaxSalaryValidation('');
            }
        }
        if (e.target.id == 'no_of_resource' && e.target.value != '') {
            let regexItem = new RegExp('^[0-9]*$');
            let check = regexItem.test(e.target.value);
            if (check == false) {
                setResourceValidation('Enter a Valid # of Resources Needed');
            } else {
                setResourceValidation('');
            }
        }

        if (e.target.id == 'remoteAccess') {
            setFormData((formData) => ({
                ...formData,
                [e.target.name]: e.target.checked,
            }));
            setRemoteDisable(e.target.checked);
            setFormData((formData) => ({
                ...formData,
                ['location']: '',
            }));
            if (e.target.checked) {
                setLocationValidation('');
            } else {
                setLocationValidation('Location is required');
            }
        } else if (e.target.name === 'number') {
            // if (/^[0-9\b]+$/.test(e.target.value) || e.target.value == "") {
            setFormData({ ...formData, [e.target.id]: e.target.value });
            // }
        } else if (e.target.name === 'dropdown') {
            setFormData({ ...formData, [e.target.id]: e.target.value.split('@')[0] });
            setPreviewData({
                ...previewData,
                [e.target.id]: e.target.value.split('@')[1],
            });
        } else {
            setFormData({ ...formData, [e.target.id]: e.target.value });
        }
    };



    // const handleChange = (e) => {
    //     if (e.target.id === 'remoteAccess') {
    //         // Handle remote access toggle and location field
    //         setFormData((formData) => ({
    //             ...formData,
    //             [e.target.name]: e.target.checked,
    //         }));
    //         setRemoteDisable(e.target.checked);
    //         if (e.target.checked) {
    //             setFormData((formData) => ({
    //                 ...formData,
    //                 ['location']: '',
    //             }));
    //             setLocationValidation('');
    //         } else {
    //             setLocationValidation('Location is required');
    //         }
    //     } else if (e.target.name === 'number') {
    //         // Handle input for phone numbers
    //         setFormData({ ...formData, [e.target.id]: e.target.value });
    //     } else if (e.target.name === 'dropdown') {
    //         // Handle dropdown for location
    //         setFormData({ ...formData, [e.target.id]: e.target.value.split('@')[0] });
    //         setPreviewData({
    //             ...previewData,
    //             [e.target.id]: e.target.value.split('@')[1],
    //         });
    //     } else if (e.target.name === 'sourceDropdown') {
    //         // Handle dropdown for source
    //         const selectedValue = e.target.value.split('@')[0];
    //         const previewValue = e.target.value.split('@')[1];
    //         setFormData({ ...formData, ['source']: selectedValue });
    //         setPreviewData({
    //             ...previewData,
    //             ['source']: previewValue,
    //         });
    //         // Optionally, add any source-specific validations
    //         if (selectedValue === '') {
    //             setSourceValidation('Source is required');
    //         } else {
    //             setSourceValidation('');
    //         }
    //     } else {
    //         // Handle all other inputs
    //         setFormData({ ...formData, [e.target.id]: e.target.value });
    //     }
    // };






    let formValidation = () => {
        let result = true;

        if (formData.jobTitle == '') {
            setJobtitleValidation('Job Title is required');
            result = false;
        }

        // if (formData.departmentID == 0) {
        //     setDepartmentValidation('Department is required');
        //     result = false;
        // }
        if (formData.employmentID == 0) {
            setEmploymentValidation('Employment Type is required');
            result = false;
        }
        if (formData.no_of_resource == 0) {
            setResourceValidation('Number of resource is required');
            result = false;
        }
        if (formData.currencyID == 0) {
            setCurrencyValidation('Currency is required');
            result = false;
        }
        if (formData.minSalary == '') {
            setMinSalaryValidation('Min Salary is required');
            result = false;
        }
        if (formData.maxSalary == '') {
            setMaxSalaryValidation('Max Salary is required');
            result = false;
        }
        let regexItem = new RegExp('^[0-9]*$');
        if (formData.minSalary !== '') {
            let checkValid = regexItem.test(formData.minSalary);
            if (isNaN(formData.minSalary)) {
                setMinSalaryValidation('Enter a Valid Min Salary');
                result = false;
            }
        }
        if (formData.maxSalary !== '') {
            let check = regexItem.test(formData.maxSalary);
            if (isNaN(formData.maxSalary)) {
                setMaxSalaryValidation('Enter a Valid Max Salary');
                result = false;
            }
        }
        if (formData.no_of_resource !== '') {
            let checkresource = regexItem.test(formData.no_of_resource);
            if (checkresource == false) {
                setResourceValidation('Enter a Valid No of Resource');
                result = false;
            }
        }
        if (parseInt(formData.minSalary) > parseInt(formData.maxSalary)) {
            setMinSalaryValidation('Min Salary must be less than or equal to max salary');
            result = false;
        }
        if (parseInt(formData.maxSalary) > parseInt(formData.minSalary)) {
            if (parseInt(formData.minSalary) !== '') {
                setMinSalaryValidation('');
            }
        }

        if (formData.payoutFrequency == 0) {
            setPayoutValidation('Payout Frequency is required');
            result = false;
        }
        if (formData.location == '' && formData.remoteJob == false) {
            setLocationValidation('Location is required');
            result = false;
        }
        if (formData.experience == '') {
            setExperienceValidation('Experience is required');
            result = false;
        }
        if (formData.sourceID == '') {
            setSourceValidation('Source is required');
            result = false;
        }
        if (formData.college == '' && formData.sourceID == 1) {
            setCollegeValidation('College is required');
            result = false;
        }
        // if (formData.skills == '') {
        //     setSkillValidation('Skills is required');
        //     result = false;
        // }
        if (convertedText == '' || convertedText == '<p><br></p>') {
            setDescriptionValidation('Description is required');
            result = false;
        }
        // if (
        //     formData.jobTitle != '' &&
        //     // formData.departmentID != 0 &&
        //     formData.employmentID != 0 &&
        //     formData.no_of_resource != 0 &&
        //     formData.currencyID != 0 &&
        //     formData.minSalary != '' &&
        //     formData.maxSalary != '' &&
        //     formData.payoutFrequency != 0 &&
        //     formData.experience != '' &&
        //     // formData.skills != '' &&
        //     convertedText != '' &&
        //     formData.maxSalary >= formData.minSalary
        // ) {
        if (formData.location == '' && formData.remoteJob == true) {
            // result = true;
        } else if (formData.location !== '' && formData.remoteJob == false) {
            // result = true;
        } else {
            result = false;
        }
        // if (formData.sourceID == '' && formData.remoteJob == true) {
        //     // result = true;
        // } else if (formData.sourceID !== '' && formData.remoteJob == false) {
        //     // result = true;
        // } else {
        //     result = false;
        // }
        // if (formData.college == '' && formData.remoteJob == true) {
        //     // result = true;
        // } else if (formData.college !== '' && formData.remoteJob == false) {
        //     // result = true;
        // } else {
        //     result = false;
        // }
        if (formData.jobTitle !== '') {
            let checkregexjtitle = OnlyNumberSpecialChar(formData.jobTitle);
            if (checkregexjtitle) {
                setJobtitleValidation('Job title is not Valid');
                result = false;
            } else {
                setJobtitleValidation('');
            }
        }
        if (convertedText !== '' && convertedText !== '<p><br></p>') {
            let checkregex = OnlyNumberSpecialChar(convertedText);
            if (checkregex) {
                setDescriptionValidation('Description is not valid');
                result = false;
            } else {
                setDescriptionValidation('');
            }
        }
        if (formData.skills !== '') {
            let checkregexskill = OnlyNumberSpecialChar(formData.skills);
            if (checkregexskill) {
                setSkillValidation('Skills is not Valid');
                result = false;
            } else {
                setSkillValidation('');
            }
        }
        return result;
    };
/**
 * PS_29 -- Validation function gets triggers
 */
    let submitData = async (save) => {
        if (save == 'Draft') {
            formData.draft = true;
        } else {
            formData.draft = false;
        }
        if (save == 'Insert') {
            let result = formValidation();
        } else {
            let result = formValidation();
        }
        if (jobEditId != null) {
            formData.isHold = false;

            formData.isClosed = false;
            formData.isDeleted = false;
        }

        formData.isPublished = false;
/**
 * PS_30 - PS_31 -- postJobData have been triggered
 */
        if (save == 'Insert' && formValidation() == true) {
            let value = formData;
            value['description'] = convertedText;
            let response = await postJobData(formData);
            
            
            setIsLoading(true);

            if (response.data.statusCode == 200) {
                setHideSuccessPopup(true);
                navigate(`/Recruitment/Jobs?id=${response.data.data[0].id}&job=publish`);
            }
        } else if (save == 'Draft' && formValidation() == true) {
            let value = formData;
            value['description'] = convertedText;

            let response = await postJobData(formData);
            setIsLoading(true);
            if (response.data.statusCode == 200) {
                setHideSuccessPopup(true);
                navigate('/Recruitment');
            }
        }
    };

    let bindDepartment = () => {
        
        try {
            return departmentDD.map((obj, index) => {
                return (
                    <option key={index} value={obj.id + '@' + obj.department}>
                        {obj.department}
                    </option>
                );
            });
        } catch (e) { }
    };

    let bindEmpType = () => {
        try {
            return empTypeDD.map((obj, index) => {
                return (
                    <option key={index} value={obj.id + '@' + obj.employment_type}>
                        {obj.employment_type}
                    </option>
                );
            });
        } catch (e) { }
    };

    let bindCurrency = () => {
        
        try {
            return currencyDD.map((obj, index) => {
                return (
                    <option key={index} value={obj.id + '@' + obj.currency_type}>
                        {obj.currency_type}
                    </option>
                );
            });
        } catch (e) { }
    };

    let bindPayFrequency = () => {
        try {
            return payFrequencyDD.map((obj, index) => {
                return (
                    <option key={index} value={obj.id + '@' + obj.frequency}>
                        {obj.frequency}
                    </option>
                );
            });
        } catch (e) { }
    };
/**
 * PS_22 -- bindSource function have been declared
 */
    let bindSource = () => {
        
        try {
            return sourceDD.map((obj, index) => {
                return (
                    <option key={index} value={obj.id + '@' + obj.job_source_name}>
                        {obj.job_source_name}
                    </option>
                );
            });
        } catch (e) { }
    };

    /**
     * PS_23 -- bindCollege function is declared
     */
    let bindCollege = () => {
        
        try {
            return collegeDD.map((obj, index) => {
                return (
                    <option key={index} value={obj.id + '@' + obj.college_name}>
                        {obj.college_name}
                    </option>
                );
            });
        } catch (e) { }
    };

    // let bindExperience = () => {
    //      return experienceDD.map((obj) => {
    //           return (<option value={obj.id}>{obj}</option>);
    //      })
    // }

    // let handleChange = (e) => {
    //      typeSkills.push(e.target.value);
    // }

    return (
        <div>
            <div className="recruitment-parent-container">
                <div className="container-fluid ">
                    <div className="row justify-content-center mt-5">
                        <BreadCrumbs data={breadCrumbsData}></BreadCrumbs>
                        <div className="col-md-12 bg-white ">
                            <div className="row justify-content-center">
                                {/*Job Posting form starts here*/}
                                <div className="col-md-7 my-4">
                                    <div className="row align-items-center">
                                        <div className="col-md-12 mb-3">
                                            <label className="bold-text hive-form-label font-20 mb-5" htmlFor="job-title">
                                                What's the job you are hiring for?
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control custom-textfield job-posting-form-control semi-bold-text job-posting-spacing job-posting-spacing"
                                                value={formData.jobTitle}
                                                onChange={onValueChange}
                                                id="jobTitle"
                                                maxLength={50}
                                                placeholder="Job title"
                                            />
                                            <span style={{ color: 'red' }}>{jobtitleValidation}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="department">
                                                Department
                                                {/* <span className="hive-form-mandatory">*</span> */}
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                onChange={onValueChange}
                                                id="departmentID"
                                                name="dropdown"
                                                value={formData.departmentID + '@' + previewData.departmentID}
                                            >
                                                <option value="">Select</option>
                                                {bindDepartment()}
                                            </select>
                                            <span style={{ color: 'red' }}>{departmentValidation}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="emp-type">
                                                Employment Type
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                onChange={onValueChange}
                                                id="employmentID"
                                                name="dropdown"
                                                value={formData.employmentID + '@' + previewData.employmentID}
                                            >
                                                <option value="">Select</option>
                                                {bindEmpType()}
                                            </select>
                                            <span style={{ color: 'red' }}>{employmentValidation}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="resource-count">
                                                # of Resources Needed
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                min="0"
                                                className="form-control hive-form-control"
                                                name="number"
                                                value={formData.no_of_resource}
                                                onChange={onValueChange}
                                                id="no_of_resource"
                                                placeholder="Enter # of resources"
                                            />
                                            <span style={{ color: 'red' }}>{resourceValidation}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="currency">
                                                Currency<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                onChange={onValueChange}
                                                id="currencyID"
                                                value={formData.currencyID + '@' + previewData.currencyID}
                                                name="dropdown"
                                            >
                                                <option value="">Select</option>
                                                {bindCurrency()}
                                            </select>
                                            <span style={{ color: 'red' }}>{currencyValidation}</span>
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="min-salary">
                                                Min Salary<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                value={formData.minSalary}
                                                name="number"
                                                onChange={onValueChange}
                                                id="minSalary"
                                                min="0"
                                                placeholder="Enter Min Salary "
                                            />
                                            <span style={{ color: 'red' }}>{minSalaryValidation}</span>
                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="max-salary">
                                                Max Salary<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                value={formData.maxSalary}
                                                name="number"
                                                onChange={onValueChange}
                                                id="maxSalary"
                                                min="0"
                                                placeholder="Enter Max Salary "
                                            />
                                            <span style={{ color: 'red' }}>{maxSalaryValidation}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="payout">
                                                Payout Frequency
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                onChange={onValueChange}
                                                value={formData.payoutFrequency + '@' + previewData.payoutFrequency}
                                                id="payoutFrequency"
                                                name="dropdown"
                                            >
                                                <option value="">Select</option>
                                                {bindPayFrequency()}
                                            </select>
                                            <span style={{ color: 'red' }}>{payoutValidation}</span>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="location">
                                                Location<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                value={formData.location}
                                                onChange={onValueChange}
                                                id="location"
                                                disabled={remoteDisable == true ? true : false}
                                            >
                                                <option value="">Select</option>
                                                <option value={'India'}>India</option>
                                                <option value={'USA'}>USA</option>
                                            </select>
                                            <span style={{ color: 'red' }}>{locationValidation}</span>
                                        </div>
                                        <div className="col-md-4 ">
                                            <input
                                                className="form-check-input hive-form-check-input me-2 job-posting-checkbox"
                                                type="checkbox"
                                                name="remoteJob"
                                                onChange={onValueChange}
                                                id="remoteAccess"
                                            />
                                            <label
                                                className="form-check-label hive-form-check-label font-13 semibold-text"
                                                htmlFor="remote"
                                            >
                                                Mark as Remote Job
                                            </label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="experience">
                                                Experience<span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                value={formData.experience}
                                                onChange={onValueChange}
                                                id="experience"
                                            >
                                                <option value="">Select</option>
                                                <option value="Fresher">Fresher</option>
                                                <option value="Experienced">Experienced</option>
                                            </select>
                                            <span style={{ color: 'red' }}>{experienceValidation}</span>
                                        </div>
                                        {/**
                                         * PS_24, PS_26, PS_27 --User Selects a value from source and college dropdown
                                         */}
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="source">
                                                Source
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            <select
                                                className="form-select hive-form-select"
                                                onChange={onValueChange}
                                                id="sourceID"
                                                name="dropdown"
                                                value={formData.sourceID + '@' + previewData.sourceID}
                                            >
                                                <option value="">Select</option>
                                                {bindSource()}
                                            </select>
                                            <span style={{ color: 'red' }}>{sourceValidation}</span>
                                        </div>
                                        {previewData.sourceID === 'Placement' ?
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="college">
                                                    College
                                                    <span className="hive-form-mandatory">*</span>
                                                </label>
                                                <select
                                                    className="form-select hive-form-select"
                                                    onChange={onValueChange}
                                                    id="college"
                                                    name="dropdown"
                                                    value={formData.college + '@' + previewData.college}
                                                >
                                                    <option value="">Select</option>
                                                    {bindCollege()}
                                                </select>
                                                <span style={{ color: 'red' }}>{collegeValidation}</span>
                                            </div> : null
          }




                                        <div className="col-md-12 mb-3">
                                            <label className="form-label hive-form-label" htmlFor="skills">
                                                Skills
                                                {/* <span className="hive-form-mandatory">*</span> */}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control hive-form-control"
                                                value={formData.skills}
                                                onChange={onValueChange}
                                                id="skills"
                                                maxLength={1000}
                                                placeholder="Enter the skills"
                                            />
                                            {/* <Select className="dropdown" name='assigned_to_id' maxMenuHeight={100} placeholder="Select attendees" value={typeSkills} onChange={handleChange} isMulti isClearable /> */}
                                            <span style={{ color: 'red' }}>{skillValidation}</span>
                                        </div>
                                        <div className="col-md-12 mb-5">
                                            <label className="form-label hive-form-label" htmlFor="job-description">
                                                Job Description
                                                <span className="hive-form-mandatory">*</span>
                                            </label>
                                            {/* <textarea
                                                className="form-control hive-form-control job-posting-commentbox"
                                                value={formData.description}
                                                onChange={onValueChange}
                                                
                                                id="description"
                                                maxLength={1500}
                                                placeholder="Enter Job Descriptions"
                                            /> */}
                                            <ReactQuill
                                                theme="snow"
                                                id="description"
                                                className="  job-posting-commentbox"
                                                value={convertedText}
                                                onChange={setConvertedText}
                                                style={{ minHeight: '100px' }}
                                            />
                                        </div>
                                        <span className="mt-3" style={{ color: 'red' }}>
                                            {descriptionValidation}
                                        </span>
                                        <div className="col-md-12 d-flex justify-content-end pb-4 mt-5">
                                            <button
                                                className="btn hive-btn-secondary me-1"
                                                onClick={() => {
                                                    window.location.href = '/Recruitment';
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="btn hive-btn-outline me-3"
                                                onClick={() => {
                                                    //debugger;
                                                    submitData('Draft');
                                                }}
                                            >
                                                Save as Draft
                                            </button>
                                            <button
                                                className="btn skill-previous-button me-3"
                                                data-bs-toggle="modal"
                                                data-bs-target="#JobPostingPreview"
                                            >
                                                Preview
                                            </button>
                                            <button
                                                className="btn hive-btn-primary"
                                                data-bs-toggle="modal"
                                                data-bs-target="#PublishMessage"
                                                onClick={() => {
                                                    submitData('Insert');
                                                }}
                                            >
                                                Publish
                                            </button>
                                        </div>
                                        {/* Modal for preview job posting info */}
                                        <div
                                            className="modal fade"
                                            id="JobPostingPreview"
                                            data-bs-backdrop="static"
                                            data-bs-keyboard="false"
                                            tabIndex={-1}
                                            aria-labelledby="JobPostingPreviewLabel"
                                            aria-hidden="true"
                                        >
                                            <div className="modal-dialog preview-modal-size  modal-dialog-centered">
                                                <div className="modal-content preview-modal-curve">
                                                    <div className="modal-header border-0">
                                                        <p
                                                            className="modal-title job-posting-preview-header font-16 semibold-text"
                                                            id="JobPostingPreviewLabel"
                                                        >
                                                            Job Posting Preview
                                                        </p>
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                        />
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <label className="font-14 semibold-text job-preview-subheader">Title</label>
                                                                <p className="font-18 bold-text job-preview-text">{formData.jobTitle}</p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="font-13 semibold-text job-preview-label">
                                                                    Department
                                                                </label>
                                                                <p className="font-14 semibold-text job-preview-text">
                                                                    {previewData.departmentID}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="font-13 semibold-text job-preview-label">
                                                                    Source
                                                                </label>
                                                                <p className="font-14 semibold-text job-preview-text">
                                                                    {previewData.sourceID}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="font-13 semibold-text job-preview-label">
                                                                    College
                                                                </label>
                                                                <p className="font-14 semibold-text job-preview-text">
                                                                    {previewData.college}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="font-13 semibold-text job-preview-label">Location</label>
                                                                <p className="font-14 semibold-text job-preview-text">
                                                                    {formData.location}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="font-13 semibold-text job-preview-label">Job Type</label>
                                                                <p className="font-14 semibold-text job-preview-text">
                                                                    {previewData.employmentID}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label className="font-13 semibold-text job-preview-label">
                                                                    Salary Details
                                                                </label>
                                                                <p className="font-14 semibold-text job-preview-text">
                                                                    <span>{previewData.currencyID}: </span> {formData.minSalary} -{' '}
                                                                    {formData.maxSalary} <span>per annum</span>
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <label className="font-13 semibold-text job-preview-label">
                                                                    Experience
                                                                </label>
                                                                <p className="font-14 semibold-text job-preview-text">
                                                                    {formData.experience}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <p className="font-15 mb-3 semibold-text job-preview-text">
                                                                    Job Description
                                                                </p>
                                                                <div className="col-md-12 mb-3">
                                                                    <p className=" job-preview-description b-3">
                                                                        {' '}
                                                                        <div dangerouslySetInnerHTML={{ __html: convertedText }}></div>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Modal for preview job posting info */}
                                        {/* Modal for preview job posting info */}
                                        <div className="Success-PopUp pop-bg" hidden={hideSuccessPopup}>
                                            <div className="modal-dialog modal-dialog-centered published-modal-size ">
                                                <div className="modal-content preview-modal-curve">
                                                    <div className="modal-header border-0 pb-0">
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setHideSuccessPopup(true);
                                                                window.location.href = '/Recruitment';
                                                            }}
                                                            className="btn-close"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                        />
                                                    </div>
                                                    <div className="modal-body job-success-modal">
                                                        <div className="row justify-content-center">
                                                            <div className="col-md-12 text-center mb-4">
                                                                <img src="/Images/published-popup-icon.svg" />
                                                            </div>
                                                            <div className="col-md-10 text-center mb-4">
                                                                <p className="font-14 semibold-text job-success-text">
                                                                    This job posting has been successfully published on your{' '}
                                                                    <a href="#" className="job-career-site">
                                                                        career site
                                                                    </a>
                                                                </p>
                                                            </div>
                                                            <div className="row justify-content-center border-0 py-3 job-success-popup-footer">
                                                                <div className="col-auto mb-2">
                                                                    <p className=" font-14 semibold-text job-success-text">
                                                                        Attract candidates by posting this job to third party job sites
                                                                    </p>
                                                                </div>
                                                                <div className="col-auto mb-2">
                                                                    <button
                                                                        type="button"
                                                                        className="btn hive-btn-primary"
                                                                        onClick={() => {
                                                                            setHideSuccessPopup(true);
                                                                            window.location.href = '/Recruitment';
                                                                        }}
                                                                    >
                                                                        Post to Job Sites
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Modal for preview job posting info */}
                                    </div>
                                </div>
                                {/*Job Posting form ends here*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

